import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";
import { CoreUserFeedback } from "@mm-products/java-multima-framework";
import target = CoreUserFeedback.target;

type FeedbackSlice = CommonTableState & {
    feedbacks: Array<CoreUserFeedback>;
};

const initialState: FeedbackSlice = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnOrder: ["mrt-row-expand", "type", "user.id", "rating", "state", "target", "created"],
        density: "compact",
    },
    feedbacks: [],
};

export const feedbackSlice = createSlice({
    name: "feedback",
    initialState: initialState,
    reducers: {
        updateFeedbackTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
        feedbackDone: (state, action: PayloadAction<CoreUserFeedback>) => {
            if (action.payload.target !== target.WEB) {
                return;
            }
            state.feedbacks = state.feedbacks.filter((feedback) => feedback.id !== action.payload.id);
        },
        addFeedback: (state, action: PayloadAction<CoreUserFeedback>) => {
            if (action.payload.target !== target.WEB) {
                return;
            }
            const feedbackAlreadyExists = state.feedbacks.some((feedback) => feedback.id === action.payload.id);
            if (!feedbackAlreadyExists) {
                state.feedbacks = [...state.feedbacks, action.payload];
            }
        },
        removeFeedback: (state, action: PayloadAction<CoreUserFeedback | string>) => {
            if (typeof action.payload === "object" && !action.payload.id) {
                state.feedbacks = state.feedbacks.filter((feedback) => feedback.id !== undefined);
                return;
            }
            state.feedbacks = state.feedbacks.filter((feedback) => {
                if (typeof action.payload === "string") {
                    return feedback.id !== action.payload;
                }
                return feedback.id !== action.payload.id;
            });
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    updateFeedbackTableState, feedbackDone,
    removeFeedback,
    addFeedback,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;
